import React, { memo, useState, useEffect } from "react";
import { getTwoDecimalPlaces } from "../../../helpers/PriceDigest";
import GoogleMap from "../../shared/map";
import { Link } from "react-router-dom";
import {
  ResultMain,
  ResultMainWrap,
  ResultHeader,
  ResultMap,
} from "./styles/TransactionResultStyle";
import { formatDateTime } from "../../../helpers/formatTime";
import { useNavigate } from "react-router-dom";

const TransactionResult = ({ status = "", Data = [] }) => {
  const navigate = useNavigate();
  const [PickUpLocation, SetPickUpLocation] = useState([]);
  const [DropoffLocation, SetDropoffLocation] = useState([]);
  const { id, order, created_at } = Data;

  useEffect(() => {
    if (Data && order?.stops && order.stops.length > 0) {
      SetPickUpLocation({
        lat: order?.stops[0]?.location?.latitude,
        lng: order?.stops[0]?.location?.longitude,
      });
      SetDropoffLocation({
        lat: order?.stops[1]?.location?.latitude,
        lng: order?.stops[1]?.location?.longitude,
      });
    }
  }, [Data]);

  const GotoTransactionDetails = (id) => {
    navigate(`/transaction-details?id=${id}`);
  };

  return (
    <ResultMain>
      <ResultMainWrap>
        <ResultHeader>
          {/* <Link to={`/transaction-details?id=${id}`}> */}
          <Link to="#">{formatDateTime(created_at)}</Link>
          <div className="order_id_main">
            <span className="Order_ID">Order-ID</span>
            <span className="dash">-</span>
            <Link
              to={`/order-details?id=${order?.order_id}`}
              className="order_id"
            >
              {order?.order_id}
            </Link>
          </div>
          <h6>${getTwoDecimalPlaces(Data?.amount)}</h6>
        </ResultHeader>
        <ResultMap>
          {Data && order?.stops && order.stops.length > 0 && (
            <GoogleMap
              LocationIcon={false}
              hasRoutes={true}
              PichUpLocation={PickUpLocation}
              DropoffLocation={DropoffLocation}
            />
          )}
          <span onClick={() => GotoTransactionDetails(id)}>{status}</span>
        </ResultMap>
      </ResultMainWrap>
    </ResultMain>
  );
};

export default memo(TransactionResult);
